module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAH1JREFUKFOd0MEKQVEQBuBv3gFvaO0NbCgSNsrGSyk2kkdhNOrWjXspZ3nO18z5//B2MnOMIZYR8WieowOOcMECm4i4l/mAdZmZhU/YY164E7bwGVusemEL37D+BQe41he+ra7kRxww+z9MZta6qmf3mtRXT2ZOUPVMG1TBnh87NQjGPWdjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/leftIcon.png
// module id = 7w+2
// module chunks = 44